import React, { Component } from "react"
import { Helmet } from "react-helmet"
import PurchaseCard from "../PurchaseCard"
import Modal from "../Modal"
import RequestAccessModal from "../RequestAccessModal"
import Button from "../Button"
import Dropdown from "../Dropdown"
import { structureEventData } from "../../shared/structureData"
import moment from "moment"
import qs from "qs"
import { etrColorInsights } from "../../shared/images"
import { showDownloadBtnForTrialUser } from "../../shared/helpers"
import AppContext from "../../shared/AppContext"
import Favorite, { FavoriteButton } from "../FavoriteButton"

import "./vennDetails.scss"
import VennTranscript from "../VennTranscript"

const fileIcons = {
  Transcript: "glyphicon glyphicon-duplicate",
  Abstract: "glyphicon glyphicon-file",
  "Event Deck": "glyphicon glyphicon-blackboard",
  "Full Recording": "glyphicon glyphicon-play-circle",
}

class VennDetails extends Component {
  state = {
    isUpcoming: false,
    eventDate: null,
    isModalOpen: false,
    isRequestAccess: false,
    isRequestAccessSuccess: false,
    selectedFile: 0,
    hasLogo: false,
  }

  static getDerivedStateFromProps = (props, state) => {
    const { metadata } = props.data.page

    let date =
      metadata && metadata["Event Date"] && moment.utc(metadata["Event Date"])
    let dateTime = moment(
      metadata["Event Time"].replace(/.{2}$/, " $&"),
      "HH:mm A"
    )
    let currentTime = moment()

    let isAfter = date.isAfter(moment())
    if (date.isSame(moment(), "day")) {
      isAfter = dateTime.isAfter(currentTime)
    }

    return {
      ...state,
      eventDate: date,
      isUpcoming: date && isAfter,
    }
  }

  openRequestAccessModal = () => {
    this.props.onRequestEventAccessClick()
    this.setState({
      isModalOpen: true,
      isRequestAccess: true,
      isRequestAccessSuccess: false,
    })
  }

  closeModal = () =>
    this.setState({
      isModalOpen: false,
      isRequestAccess: false,
      isRequestAccessSuccess: false,
    })

  requestEventAccess = (args) => {
    this.props
      .requestAccess({
        variables: {
          type: "venn-access",
          productId: this.props.data.page.id,
          name: `${args.first} ${args.last}`,
          time: moment(args.time, "HH:mm").utc().format("HH:mm"),
          ...args,
        },
      })
      .then(({ data }) => {
        if (data.requestAccessToProduct.payload === "success") {
          this.props.onRequestAccessSuccess()
          this.setState({ requestAccessSuccess: true })
        } else {
          alert(
            `Unable to process your request: ${data.requestAccessToProduct.message}`
          )
        }
      })
      .catch((_) => alert("Unable to process your request"))

    this.setState({
      isRequestAccessSuccess: true,
    })
  }

  selectFile = (e) => {
    this.setState({
      selectedFile: e.value,
    })
  }

  renderFavoriteButton = () => {
    return (
      <Favorite
        className="rounded button-item"
        trackingLocation="Product View ETR Insights"
        favoriteData={{
          name: this.props.data.page.name,
          description: this.props.data.page.previewDescription,
          favoriteType: "REPORT",
          slug: this.props.location.pathname,
          metadata: {
            productId: this.props.data.page.id,
            imageURL:
              this.props.data.page.logo ||
              "/static/images/ETR-color-insights-logo.png",
          },
        }}
        favoriteType="REPORT"
        location={this.props.location}
        variables={{ productId: this.props.data.page.id }}
      >
        <FavoriteButton className="btn-favorite-outline-orange rounded button-item" />
      </Favorite>
    )
  }

  _renderPateinceText = () => {
    let { files, available, isSpecialAccess } = this.props.data.page
    let { isUpcoming } = this.state

    if ((!files || files.length === 0) && !isUpcoming && !available) {
      return (
        <div className="venn-details-title-container">
          <div className="venn-details-title-content">
            <h2>
              <b>Patience.</b> Producing well-curated qualitative deliverables
              takes time. The content for this event will be up soon.
            </h2>
          </div>
          {isSpecialAccess && (
            <div style={{ maxWidth: "210px", padding: "20px 0" }}>
              {this.renderFavoriteButton()}
            </div>
          )}
        </div>
      )
    } else {
      return null
    }
  }

  _renderPurchaseCards = () => {
    let { isSpecialAccess, isForSale, isPurchased, files, free, available } =
      this.props.data.page

    const canView =
      (isSpecialAccess || free || isPurchased) &&
      available &&
      files &&
      files.length

    const showDownload = showDownloadBtnForTrialUser(
      this.props.data.viewer,
      isPurchased,
      free
    )

    let { isUpcoming, selectedFile } = this.state
    if (isSpecialAccess || free) {
      if (!files) {
        return null
      }

      let file = files[selectedFile]
      return (
        file && (
          <div id="file-selector">
            <Dropdown
              data-cy="venn-file-selector"
              defaultValue={selectedFile}
              label="Select a file:"
              options={files.map(({ name }, i) => ({ name, value: i }))}
              onChange={this.selectFile}
            />
            <div className="etr-insights-details-buttons-container">
              <div className="button-item">
                <Button
                  data-cy="view-product-button"
                  classes={["dark-fill", "small-caps"]}
                  fullWidth
                  disabled={!canView}
                  action={(_) => this.props.view(selectedFile)}
                >
                  View {file.name}
                  <span
                    className="glyphicon glyphicon-eye-open"
                    style={{ marginLeft: 5 }}
                  />
                </Button>
              </div>
              {showDownload && (
                <div className="button-item">
                  <Button
                    data-cy="download-product-button"
                    classes={["green-fill", "small-caps"]}
                    fullWidth
                    download={file.downloadUrl}
                    action={this.props.download(selectedFile)}
                    disabled={!canView || !file.downloadUrl}
                  >
                    Download {file.name}
                    <span
                      className="glyphicon glyphicon-download-alt"
                      style={{ marginLeft: 5 }}
                    />
                  </Button>
                </div>
              )}
              {this.renderFavoriteButton()}
            </div>
          </div>
        )
      )
    } else if (isUpcoming) {
      return (
        <div className="etr-insights-details-buttons-container">
          <PurchaseCard
            description="Are you an IT Decision Maker?"
            buttonText="REQUEST FREE ACCESS"
            buttonAction={this.openRequestAccessModal}
          />
          <div className="purchase-card-container">
            {this.renderFavoriteButton()}
          </div>
        </div>
      )
    } else {
      return (
        <div className="etr-insights-details-buttons-container">
          {this.props.purchase && <PurchaseCard {...this.props.purchase} />}
          {isForSale && (
            <PurchaseCard
              subscription
              recommended
              description=""
              buttonText="INQUIRE FOR PRICING"
              buttonAction={() =>
                this.props.openInquireModal(
                  this.props.serviceType.UpgradePlan,
                  "Venn Details: Inquire For Pricing Button"
                )
              }
              data-cy="purchase-card-inquire-button"
            />
          )}
          <PurchaseCard
            description="Are you an IT Decision Maker?"
            buttonText="REQUEST FREE ACCESS"
            buttonAction={this.openRequestAccessModal}
            buttonClasses={["btn-primary", "btn-outline"]}
          />
          <div className="purchase-card-container">
            {this.renderFavoriteButton()}
          </div>
        </div>
      )
    }
  }

  _renderDetails = () => {
    let { isUpcoming, eventDate } = this.state

    let {
      Speakers,
      ["Event Type"]: eventType,
      ["Event Location"]: eventLocation,
      ["Event Address"]: eventAddress,
      ["Event Time"]: eventTime,
    } = this.props.data.page.metadata

    let detailItems = [
      {
        icon: "https://s3.amazonaws.com/dev-etr/images/venn_when.png",
        title: "When?",
        item1: eventDate ? moment(eventDate).format("D MMM YYYY") : "TBD",
        item2: eventTime
          ? moment(eventTime, "hh:mmA").format("h:mm A [(EST)]")
          : undefined,
      },
      {
        icon: "https://s3.amazonaws.com/dev-etr/images/venn_where.png",
        title: "Where?",
        item1: isUpcoming ? "New York, NY" : eventLocation,
        item2: isUpcoming ? undefined : eventAddress,
      },
    ]

    if (isUpcoming) {
      detailItems = detailItems.concat([
        {
          title: "Speaker",
          item1: Speakers[0]["Speaker Name"],
          item2: Speakers[0]["Speaker Title"],
        },
        {
          title: "Event Type",
          item1: eventType,
          item2: "Exclusive Event",
        },
      ])
    }

    return (
      <div className="venn-details-event-details-container">
        <div className="venn-details-event-details-content">
          {detailItems.map((item, i) => (
            <div key={i} className="venn-details-event-details-item">
              <div className="venn-event-item-image-container">
                <div
                  className="icon"
                  style={{ backgroundImage: `url('${item.icon}')` }}
                />
              </div>
              <div className="venn-event-item-content">
                <span>{item.title}</span>
                <h2>{item.item1}</h2>
                <p>{item.item2}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  _renderFiles = () => {
    let { isSpecialAccess, free, files, available, isPurchased } =
      this.props.data.page

    let fileItems = ["Transcript", "Abstract", "Event Deck", "Full Recording"]

    const canView =
      (isSpecialAccess || free || isPurchased) &&
      available &&
      files &&
      files.length

    return (
      <div className="venn-details-description-content" id="venn-files-list">
        {fileItems.map((item, i) => {
          let extraProps = canView
            ? {
                className: "venn-file-item clickable",
                onClick: (_) => {
                  let file = files.findIndex(
                    ({ name }) => name.toLowerCase() === item.toLowerCase()
                  )
                  file != null && this.props.view(file)
                },
              }
            : {}
          return (
            <div key={i} className="venn-file-item" {...extraProps}>
              <span className={fileIcons[item] + " file-icon"} />
              <h3>{item}</h3>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    let { name, description, metadata, logo } = this.props.data.page

    let params = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    })

    let {
      Speakers,
      ["Event Type Description"]: eventTypeDescription,
      Organization,
    } = metadata

    return (
      <div>
        <Helmet>
          <title>{name}</title>
          <script type="application/ld+json">
            {JSON.stringify(structureEventData(this.props.data.page))}
          </script>
        </Helmet>
        <div className="venn-details-overview-container">
          <div className="venn-details-image-container">
            {logo ? (
              <div className="insights-logo-container">
                <img src={logo} />
              </div>
            ) : (
              <div className="default-venn-logo">
                <img
                  className="logo-xl"
                  src={etrColorInsights}
                  alt="ETR Insights"
                />
              </div>
            )}
          </div>
          <div className="venn-details-overview-content">
            <div className="venn-details-title-container">
              <div
                className={`venn-details-title-content ${
                  this.state.isUpcoming && "upcoming"
                }`}
              >
                <h1>
                  {name}
                  {Organization && " - " + Organization}
                </h1>
                <h2>{eventTypeDescription}</h2>
                {!this.state.isUpcoming && Speakers && (
                  <h2>
                    {Speakers[0]["Speaker Name"]},{" "}
                    {Speakers[0]["Speaker Title"]}
                  </h2>
                )}
              </div>
            </div>
            {this._renderDetails()}
            {!this.state.isUpcoming && (
              <React.Fragment>
                <h3>OVERVIEW</h3>
                <p>{description}</p>
              </React.Fragment>
            )}
            {this._renderPateinceText()}
          </div>
          {this._renderPurchaseCards()}
        </div>

        <VennTranscript
          card
          productId={this.props.data.page.id}
          initialKeyword={params.keyword}
          trackEvent={this.props.trackEvent}
          marketplaceView={true}
        />

        {this.state.isUpcoming && (
          <div className="venn-details-description-container">
            <h2>Details:</h2>
            <div className="venn-details-description-content">
              {description || "We will have an update for you shortly!"}
            </div>
          </div>
        )}

        {!this.state.isUpcoming && (
          <div className="venn-details-description-container">
            <h2>What you get</h2>
            {this._renderFiles()}
          </div>
        )}

        <Modal
          isOpen={this.state.isModalOpen}
          close={this.closeModal}
          classes={["medium"]}
        >
          {this.state.isRequestAccess && (
            <RequestAccessModal
              close={this.closeModal}
              submit={this.requestEventAccess}
              success={this.state.isRequestAccessSuccess}
              successMessage="A member from our team will reach out to you shortly"
            />
          )}
        </Modal>
      </div>
    )
  }
}

const VennDetailsWithContext = (props) => {
  return (
    <AppContext.Consumer>
      {({ openInquireModal, serviceType }) => {
        return (
          <VennDetails
            {...props}
            openInquireModal={openInquireModal}
            serviceType={serviceType}
          />
        )
      }}
    </AppContext.Consumer>
  )
}

export default VennDetailsWithContext
